<div>
  @if (selectedValues?.length > 0) {
    <app-shared-chip
      [isChipSelected]="true"
      [matTooltip]="selectedValues ? formatSelectedValues(selectedValues) : null"
      matTooltipClass="tooltip-list">
      <span class="ellipsis">
        {{ selectedValuesLabel }}
      </span>
    </app-shared-chip>
    @if (params.data.isEdited && areArraysEqual() && (params.context?.isStockManager || !params.data.disabled)) {
      <app-icon-backspace-outline
        (click)="onUndoChangesClick()"
        [tooltip]="'Previous Value = ' +params.data.originalValue[params.colDef.field].value">
      </app-icon-backspace-outline>
    }
  }
</div>

